const e = {
  "3.5": "0.875rem",
  // 16px
  "4.5": "1.125rem",
  // 18px
  "4.824": "1.206rem",
  // 19.3px
  "4.876": "1.219rem",
  // 19.5px
  "5.5": "1.375rem",
  // 22px
  7: "1.75rem"
  // 28px
};
export {
  e as lineHeights
};
//# sourceMappingURL=lineHeights.es.js.map
